import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LicenseService } from '../license.service';
import { CtxPaginatedTableComponent, CtxTableFilterComponent } from 'ng-ui';
import { CtxPageHeaderComponent } from 'ng-ui';
import { UserService } from '../../users/user.service';
@Component({
  selector: 'ctx-licenses',
  templateUrl: './licenses.component.html',
  standalone: true,
  imports: [
    CtxPageHeaderComponent,
    CtxPaginatedTableComponent,
    CtxTableFilterComponent,
  ],
})
export class LicensesComponent {
  constructor(
    public route: ActivatedRoute,
    public license: LicenseService,
    public userService: UserService
  ) {}
}
